import m from 'moment';
import _ from 'lodash';
import * as ACTIONS from '../../actions/epg';
import { SET_CHANNELS } from './constants';
import { LOCAL_STORAGE_LAST_CHANNEL_SEEN } from '../../constants';

const initialState = {
  channels: [],
  data: [],
  schedules: [],
  incraseCounter: 0,
  patch: true,
  fetched: false,
  __handler: {},
  channelsGrid: [],
};

const callbackExecutor = caller => {
  if (typeof caller.action.cb === 'function') caller.action.cb();
};

const onPlayInterceptor = (group, onPlay) => {
  if (group && group.common.id === onPlay) {
    return true;
  }
  return false;
};

const mergeChannels = options => {
  const onPlay = options.state.__handler.params.channel_id;
  const { currentChannels, newChannels, state } = options;
  const result = currentChannels
    .filter(c => c.group)
    .map(chan => {
      const c = { ...chan };
      c.onPlay = onPlayInterceptor(c.group, onPlay);
      const gid = c.group_id;
      const newChannel = newChannels
        .filter(cc => cc.group_id === gid)
        .reduce((p, cc) => (p.group ? p : cc), {});
      if (!newChannel.events) {
        return c;
      }

      const infoEvents = _.uniqBy(
        _.union(c.events, newChannel.events),
        'date_begin',
      );
      const sortEvents = _.sortBy(infoEvents, [
        function(o) {
          return m(o.date_begin).format('YYYY/MM/DD HH:mm:ss');
        },
      ]);
      c.events = sortEvents;

      return c;
    });
  getTvGuide({ result, state });
  return result;
};

const getTvGuide = channels => {
  const lastChannelSeen =
    _.get(channels, 'state.__handler.params.channel_id', false) ||
    localStorage.getItem(LOCAL_STORAGE_LAST_CHANNEL_SEEN);

  const result = channels.result
    .filter(cc => cc.group_id == lastChannelSeen)
    .map(data => {
      let r = {
        events: [],
        group: {},
        group_id: data.group_id,
        hd: data.hd,
        id: data.id,
        image: data.image,
        liveref: data.liveref,
        name: data.name,
        number: data.number,
        onPlay: data.onPlay,
      };

      const events = data.events.map(eInfo => {
        let s = {
          channel_id: eInfo.channel_id,
          date_begin: eInfo.date_begin,
          date_end: eInfo.date_end,
          description: eInfo.description,
          duration: eInfo.duration,
          ext_recordable: eInfo.ext_recordable,
          ext_startover: eInfo.ext_startover,
          group_id: eInfo.group_id,
          id: eInfo.id,
          isTimeshift: eInfo.isTimeshift,
          language: eInfo.language,
          name: eInfo.name,
          talent: eInfo.talent,
          type: eInfo.type,
          nowPlaying: eInfo.nowPlaying,
          parental_rating: eInfo.parental_rating,
        };
        return s;
      });
      r.events = events;

      const group = {
        date: data.group.common.date,
        description: data.group.common.description,
        description_large: data.group.common.description_large,
        duration: data.group.common.duration,
        episode_number: data.group.common.episode_number,
        format_types: data.group.common.format_types,
        id: data.group.common.id,
        image_background: data.group.common.image_background,
        image_large: data.group.common.image_large,
        image_medium: data.group.common.image_medium,
        image_small: data.group.common.image_small,
        live_enabled: data.group.common.live_enabled,
        live_ref: data.group.common.live_ref,
        live_type: data.group.common.live_type,
        preview: data.group.common.preview,
        proveedor_code: data.group.common.proveedor_code,
        proveedor_name: data.group.common.proveedor_name,
        rating_code: data.group.common.rating_code,
        rollingcreditstime: data.group.common.rollingcreditstime,
        season_number: data.group.common.season_number,
        timeshift: data.group.common.timeshift,
        title: data.group.common.title,
        title_episode: data.group.common.title_episode,
        title_original: data.group.common.title_original,
        title_uri: data.group.common.title_uri,
        year: data.group.common.year,
      };
      r.group.common = group;
      return r;
    });
  return result[0];
};

const getDeepChannels = resp => {
  const data = [];
  resp.map((e, i) => {
    data[i] = _.get(e, 'group.common', {});
  });
  return data;
};

export default function epg(state = initialState, action) {
  callbackExecutor({ action });
  switch (action.type) {
    case SET_CHANNELS:
      return { ...state, data: action.channels };
    case ACTIONS.CHANNELS_FETCH:
      const onPlay = _.get(state, '__handler.params.channel_id', false);
      getTvGuide({ result: action.result.response.channels, state });
      return Object.assign({}, state, {
        channels: action.result.response.channels
          .map(currentChannel => {
            currentChannel.onPlay = onPlayInterceptor(
              currentChannel.group,
              onPlay,
            );
            return currentChannel;
          })
          .filter(currentChannel => currentChannel.group),
        incraseCounter: action.result.incraseCounter,
        fetched: true,
      });

    case ACTIONS.CHANNELS_PATCH:
      const currentChannels = state.channels;
      const newChannels = action.result.response.channels;
      let patch = true;
      if (newChannels.length === 0) {
        patch = false;
      }
      return Object.assign({}, state, {
        channels: mergeChannels({ currentChannels, newChannels, state }),
        patch,
        incraseCounter: action.result.incraseCounter,
      });

    case ACTIONS.CHANNELS_DATES:
      const result = action.result;
      const schedules = _.union(state.schedules, result.schedules);
      const newState = Object.assign({}, state, {
        range: result.range,
        schedules,
      });
      return newState;

    case ACTIONS.GRID_CHANNELS_FETCH:
      // eslint-disable-next-line no-case-declarations
      const channelsGrid = action.result.response.channels
        ? getDeepChannels(action.result.response.channels)
        : action.result.response.groups;

      return Object.assign({}, state, {
        channelsGrid,
      });

    default:
      return state;
  }
}
